import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getPitchDesk } from '../../DashBoard/Api';
import Loaders from '../../../../GlobalComponents/KenLoader';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export interface IPitchDeskProps {
  recordId?: string;
  Title?: string;
  fileName?: string;
}

const PitchDesk: React.FunctionComponent<IPitchDeskProps> = ({ recordId }) => {
  const theme: Theme = useTheme();
  const isMaxScreen = useMediaQuery('(min-width:1920px)');
  const isMobileScreen: boolean = useMediaQuery(theme.breakpoints.down('sm'));
  const [PitchDatas, setPitchDatas] = useState<string | undefined>();
  const [isLoading, setisLoading] = useState<Boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (recordId) {
          setisLoading(true);
          const response = await getPitchDesk(recordId);
          if (response?.data?.result?.error) {
            throw new Error(`${response?.data?.result}` || 'Network response was not ok');
          }
          const base64Data = response?.data?.data;
          if (base64Data) {
            setPitchDatas(base64Data);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setisLoading(false);
      }
    };
    fetchData();
  }, [recordId]);

  return (
    <Box component="div" padding={isMaxScreen ? '0px 30px' : '0px 20px'}>
      {isLoading && <Loaders />}
      {isMobileScreen ? (
        <Box
          component="div"
          sx={{
            width: '100%',
            height: '350px',
            overflow: 'auto',
            display: 'flex',
            alignItems: PitchDatas ? 'stretch' : 'center',
            justifyContent: PitchDatas ? 'stretch' : 'center',
            border: '1px solid #E3E3E3',
            borderRadius: '8px',
            backgroundColor: '#FCFCFC'
          }}
        >
          {PitchDatas ? (
            <iframe
              src={`data:application/pdf;base64,${PitchDatas}#toolbar=0&navpanes=0&scrollbar=0`}
              title="PDF Viewer"
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            ></iframe>
          ) : (
            <Typography fontSize="14px" fontWeight="500" color="#8A8A8A">No Data Available</Typography>
          )}
        </Box>
      ) : (
        <Grid container spacing={4}>
          <Grid item lg={2}>
            <Accordion sx={{ boxShadow: 'none', height: '340px', overflow: 'auto' }}>
              <AccordionSummary
                expandIcon={<KeyboardArrowUpIcon sx={{ height: '16px' }} />}
                sx={{
                  borderBottom: '1px solid #E3E3E3',
                  '& .MuiAccordionSummary-content': {
                    margin: '0px',
                  },
                  '& .Mui-expanded': {
                    margin: '0px',
                  },
                }}
              >
                <Typography
                  fontSize={isMaxScreen ? '16px' : '12px'}
                  fontWeight="500"
                  margin="0px 0px"
                  color="#000000"
                >
                  PitchDeck
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ 
                padding: '15px 10px', 
                height: '250px', 
                display: 'flex', 
                alignItems: PitchDatas ? 'stretch' : 'center', 
                justifyContent: PitchDatas ? 'stretch' : 'center' 
              }}>
                {PitchDatas ? (
                  <iframe
                    src={`data:application/pdf;base64,${PitchDatas}#toolbar=0&navpanes=0&scrollbar=0`}
                    title="PDF Viewer"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                  ></iframe>
                ) : (
                  <Typography fontSize="12px" fontWeight="500" color="#8A8A8A" textAlign="center">No Data Available</Typography>
                )}
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item container lg={10}>
            <Grid item lg={2.5} />
            <Grid item lg={7} height={isMaxScreen ? '380px' : '340px'} overflow="auto">
              <Box
                component="div"
                sx={{
                  border: '1px solid #00000033',
                  width: '100%',
                  height: "100%",
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '8px',
                  backgroundColor: '#FCFCFC',
                  minHeight: isMaxScreen ? '480px' : '340px'
                }}
              >
                {PitchDatas ? (
                  <iframe
                    src={`data:application/pdf;base64,${PitchDatas}#toolbar=0&navpanes=0&scrollbar=0`}
                    title="PDF Viewer"
                    width="100%"
                    height="100%"
                    style={{ border: 'none', borderRadius: '8px' }}
                  ></iframe>

                ) : (
                  <Typography fontSize="16px" fontWeight="500" color="#8A8A8A" textAlign="center">No Data Available</Typography>
                )}
              </Box>
            </Grid>
            <Grid item lg={2.5} />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default PitchDesk;